module.exports = __webpack_public_path__ + "media/images/Cart_White_2x-329891e2.png";